import elementService from "../../../js/common/ElementService";
import popupAlertService from "../../../js/common/PopupAlertService";

export default class TextPageService {
    public init(): void {
        for (const element of document.querySelectorAll<HTMLElement>(".js-copy-to-clipboard")) {
            element.addEventListener("click", () => this.copyToClipboard(element));
        }
    }

    private copyToClipboard(element: HTMLElement): void {
        this.copyValueToClipboard(elementService.elementData(element, "clipboardCopyValue"));
    }

    private copyValueToClipboard(valueToCopyToClipboard: string): void {
        try {
            void navigator.clipboard.writeText(valueToCopyToClipboard);
        } catch {
            void popupAlertService.showAlert("Nepodařilo se zkopírovat text do schránky. Zkuste to prosím ručně.");
        }
    }
}
